export const BD_ROLE_LABELS: Record<string, string> = {
    BLUEDART_SUPER_ADMIN: 'Super Admin',
    // The backend keeps BLUEDART_ZONAL_APPROVER: users_role.name is compared as a string in
    // several places there, and the role id is what every scope row points at. Only the label
    // changes, which is the whole of the rename.
    BLUEDART_ZONAL_APPROVER: 'Regional Approver',
    BLUEDART_RIDER_APPROVER: 'Rider Approver',
    BLUEDART_RIDER_VIEWER: 'Rider Viewer',
    BLUEDART_VENDOR: 'Vendor',
};

/** Role 31 keeps its historical enum name on the backend — users_role.name is compared as a
 * string in several places there — so the display label is applied here instead. */
export const roleLabel = (role?: string | null): string =>
    (role && BD_ROLE_LABELS[role]) || role || '-';

export const USER_MANAGEMENT_TABLE_COLUMNS = [
    { key: 'name', label: 'Name', width: 16 },
    { key: 'contactNumber', label: 'Mobile', width: 12 },
    { key: 'email', label: 'Official Email', width: 18 },
    { key: 'role', label: 'Role', width: 13 },
    { key: 'scopeValues', label: 'Stores / Zones / Org', width: 19 },
    { key: 'createdByName', label: 'Created By', width: 12 },
    { key: 'createdOn', label: 'Created On', width: 10 },
    { key: 'actions', label: 'Actions', width: 10 },
];

export const ROLE_FILTER_OPTIONS = Object.keys(BD_ROLE_LABELS).map((value) => ({
    value,
    label: BD_ROLE_LABELS[value],
}));

export const SCOPE_INLINE_LIMIT = 3;
